/* eslint-disable no-undef */
export const useKeyboardStore = defineStore('keyboard', () => {
  const isSpacebarDown = ref(false);
  return {
    isSpacebarDown
  };
});